import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayArea } from "../models/DelayArea";

export const getDelayAreas = async (includeDelayAssets = false) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "IncludeDelayAssets", value: includeDelayAssets },
	];

	const resp = await apiService.callV2(
		"[DEL].[GetAssetsForDelayArea]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayArea[];
	} else {
		throw new Error(resp.message || "Error fetching delay areas");
	}
};
